import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

// @ts-expect-error not typed
import EditorApprovalProvider from 'ContentEditorUI/components/approvals/EditorApprovalProvider';
import { getHasApprovalsReadAccess, getHasApprovalsWriteAccess } from '../../auth/selectors/auth';
import { useAppSelector } from '../../reducers';
import { selectArticleTitle } from '../selectors/editorSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const ExtraApplicationContainerApprovalsWrapper = ({
  children
}) => {
  const {
    articleId
  } = useParams();
  return /*#__PURE__*/_jsx(EditorApprovalProvider, {
    approvalType: "KNOWLEDGE_ARTICLE",
    restartOnConclude: true,
    hasReadAccessToProductApprovals: useSelector(getHasApprovalsReadAccess),
    hasWriteAccessToProductApprovals: useSelector(getHasApprovalsWriteAccess),
    contentId: Number(articleId) // passing articleId is the only way we can get correct objectId from crm
    ,
    assetName: useAppSelector(selectArticleTitle),
    children: children
  });
};
export default ExtraApplicationContainerApprovalsWrapper;